import { render } from "./ChartBar.vue?vue&type=template&id=2905253e"
import script from "./ChartBar.vue?vue&type=script&lang=js"
export * from "./ChartBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__